import React from "react";
import NavbarButton from "./buttons/NavbarButton";
import { Link, useLocation } from "react-router-dom";
import { Tabs } from "../../../model/Charity"
import { CentsPalette } from "../../../utils/colors";
import { translations } from "../../../utils/translations/translations-manager";


interface NavbarProps {
  sidebarToggleState: () => void
}

const Navbar: React.FC<NavbarProps> = ({ sidebarToggleState }) => {
  const location = useLocation();

  const navItems = [
    {
      tab: Tabs.report, tabLabel: translations.texts.analytics.toString(), margin: 'mb-[2vh] md:mb-3', icon: <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 4V16C2 19 3 20 5.5 20C8 20 17.8334 20 22.0001 20M6 14L11 9L15 13L21 7" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    },
    {
      tab: Tabs.schede, tabLabel: translations.texts.donations.toString(), margin: 'mb-[2vh] md:mb-3', icon: <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 8V17C4 18.5 4.5 19 6 19C7.6 19 12.5 19 15 19C16.5 19 17 18.5 17 17C17 15.4 17 7.33333 17 3.5C17 2.5 16.5 2 15.5 2C13.9 2 11.1667 2 10 2M4 8L10 2M4 8H8.5C10 8 10 8 10 6.5C10 5.7 10 3.33333 10 2M7 22H18C19.5 22 20 21 20 20C20 17.6 20 8.66667 20 5" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    },
    {
      tab: Tabs.teams, tabLabel: translations.texts.teams.toString(), margin: 'mb-[2vh] md:mb-3', icon: <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 14C14.7614 14 17 11.7614 17 9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9C7 11.7614 9.23858 14 12 14ZM12 14C7.58172 14 4 16.6863 4 20M12 14C16.4183 14 20 16.6863 20 20" stroke={CentsPalette.cents_black} strokeWidth="2" strokeLinecap="round" />
      </svg>
    },
    {
      tab: Tabs.posizioni, tabLabel: translations.texts.positions.toString(), margin: '', icon: <svg className="h-5 w-5" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 13L15 10M23 13C23 19.0751 18.0751 24 12 24C5.92487 24 1 19.0751 1 13C1 6.92488 5.92487 2.00001 12 2.00001M19 13C19 16.866 15.866 20 12 20C8.13401 20 5 16.866 5 13C5 9.13402 8.13401 6.00001 12 6.00001M15 9.50001V5.11958C15 4.98498 15.0543 4.85607 15.1505 4.76199L18.1505 1.83017C18.4671 1.52076 19 1.74508 19 2.18777V5.50001C19 5.77615 19.2239 6.00001 19.5 6.00001H22.8122C23.2549 6.00001 23.4792 6.53288 23.1698 6.84948L20.238 9.84948C20.1439 9.94574 20.015 10 19.8804 10H15.5C15.2239 10 15 9.77615 15 9.50001Z" stroke={CentsPalette.cents_black} strokeWidth="2" strokeLinecap="round" />
      </svg>
    }
  ]

  return (
    <nav className="navbar">
      <ul className="flex flex-col justify-center items-center">
        {navItems.map((item) => {
          const isSelected = location.pathname === `/${item.tab}`;
          return (
            <li className="w-full">
              <Link to={`${item.tab}`}>
                <NavbarButton text={item.tabLabel} margin={item.margin} icon={item.icon} closeSidebar={sidebarToggleState} isSelected={isSelected}></NavbarButton>
              </Link>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}

export default Navbar;